import { render, staticRenderFns } from "./tableIss.vue?vue&type=template&id=36f775d0&scoped=true"
import script from "./tableIss.vue?vue&type=script&lang=js"
export * from "./tableIss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f775d0",
  null
  
)

export default component.exports